import { readEntry, writeEntry, clearCache, newestCachedAt } from './db';
import { isNetworkError } from '../errors';
import { aplicarPendentes } from './patches';

/**
 * Política de leitura: rede primeiro, cópia local como rede de segurança.
 *
 * Com internet o comportamento é idêntico ao de antes — mesma consulta, mesma
 * frescura do dado. A cópia local só entra quando a rede falha. É de propósito
 * o caminho conservador: ler do local primeiro deixaria o app mais rápido, mas
 * abriria espaço para mostrar dado velho sem o usuário saber. Isso fica para
 * depois, se a lentidão incomodar.
 *
 * Só cai para o local em falha de CONEXÃO. Se o servidor respondeu negando —
 * sessão expirada, RLS barrando —, o certo é propagar: mostrar dado guardado
 * de quem não tem mais permissão seria pior que uma tela de erro.
 */

/**
 * Executa a consulta e guarda o resultado; se a rede falhar, devolve a última
 * cópia conhecida. Sem cópia, o erro sobe como sempre subiu.
 */
export async function cached(key, fetcher) {
  try {
    const data = await fetcher();
    // Gravar é acessório e não pode derrubar a leitura, que já deu certo.
    // Precisa de try/catch além do .catch: `writeEntry` pode estourar de forma
    // síncrona antes de devolver a promessa.
    try {
      Promise.resolve(writeEntry(key, data)).catch(err =>
        console.warn('[cache] falha ao guardar cópia local:', err?.message));
    } catch (err) {
      console.warn('[cache] falha ao guardar cópia local:', err?.message);
    }
    // O que está na fila entra por cima. Guarda-se o que veio do servidor,
    // sem as emendas — elas são estado transitório, não dado confirmado.
    return aplicarPendentes(key, data);
  } catch (err) {
    if (!isNetworkError(err)) throw err;

    const entry = await readEntry(key);
    if (!entry) throw err;

    console.info('[cache] sem conexão, usando cópia local de', key);
    return aplicarPendentes(key, entry.data);
  }
}

export { clearCache, newestCachedAt };
